export const categoryArray = ["igcse", "a-level", "ial", "ib", "ap"];

export const subjectArray = [
  ["chemistry", "math", "furmath", "economic", "biology", "physics", "eng-sl"],
  ["biology", "chemistry", "physics", "math", "economic"],
  ["biology", "chemistry", "physics", "math", "economic"],
  ["biology", "chemistry", "physics", "math", "economic"],
  ["biology", "chemistry", "physics", "math", "economic"],
];

export const boardArray = [
  // IGCSE
  [
    // Chemistry
    ["cie", "edexcel"],
    // Math
    ["cie", "edexcel"],
    // Fur Math
    ["edexcel"],
    // Economic
    ["cie", "edexcel"],
    // Biology
    ["cie", "edexcel"],
    // Physics
    ["cie", "edexcel"],
    // Eng-SL
    ["cie"],
  ],
  // A-LEVEL
  [
    // Biology
    ["cie", "edexcel"],
    // Chemistry
    ["cie", "edexcel"],
    // Physics
    ["cie", "edexcel"],
    // Math
    ["cie", "edexcel"],
    // Economic
    ["cie", "edexcel"],
  ],
  // IAL
  [
    // Biology
    ["edexcel"],
    // Chemistry
    ["edexcel"],
    // Physics
    ["edexcel"],
    // Math
    ["edexcel"],
    // Economic
    ["edexcel"],
  ],
  // IB
  [
    // Biology
    ["edexcel"],
    // Chemistry
    ["edexcel"],
    // Physics
    ["edexcel"],
    // Math
    ["edexcel"],
    // Economic
    ["edexcel"],
  ],
  // AP
  [
    // Biology
    ["edexcel"],
    // Chemistry
    ["edexcel"],
    // Physics
    ["edexcel"],
    // Math
    ["edexcel"],
    // Economic
    ["edexcel"],
  ],
];

export const paperArray = [
  // IGCSE
  [
    // Chemistry
    [
      [1, 2, 3, 4, 5, 6],
      ["1c", "2c"],
    ],
    // Math
    [
      [1, 2, 3, 4],
      ["1f", "2f", "3h", "4h", "1h", "2h"],
    ],
    // Fur Math
    [[1, 2]],
    // Economic
    [
      [1, 2, 3, 4, 5, 6],
      [1, 2],
    ],
    // Biology
    [
      [1, 2, 3, 4, 5, 6],
      ["1b", "2b"],
    ],
    // Physics
    [
      [1, 2, 3, 4, 5, 6],
      ["1p", "2p"],
    ],
    // Eng-SL
    [[1, 2, 3, 4, 5]],
  ],

  // A-LEVEL
  [
    // Biology
    [
      [1, 2, 3, 4, 5, 6],
      ["1b", "2b"],
    ],
    // Chemistry
    [
      [1, 2, 3, 4, 5, 6],
      ["1c", "2c"],
    ],
    // Physics
    [
      [1, 2, 3, 4, 5, 6],
      ["1p", "2p"],
    ],
    // Math
    [
      [1, 2, 3, 4],
      ["1f", "2f", "3h", "4h", "1h", "2h"],
    ],
    // Economic
    [
      [1, 2, 3, 4, 5, 6],
      [1, 2],
    ],
  ],
  // IAL
  [
    // Biology
    [
      [1, 2, 3, 4, 5, 6],
      ["1b", "2b"],
    ],
    // Chemistry
    [
      [1, 2, 3, 4, 5, 6],
      ["1c", "2c"],
    ],
    // Physics
    [
      [1, 2, 3, 4, 5, 6],
      ["1p", "2p"],
    ],
    // Math
    [
      [1, 2, 3, 4],
      ["1f", "2f", "3h", "4h", "1h", "2h"],
    ],
    // Economic
    [
      [1, 2, 3, 4, 5, 6],
      [1, 2],
    ],
  ],
  // IB
  [
    // Biology
    [
      [1, 2, 3, 4, 5, 6],
      ["1b", "2b"],
    ],
    // Chemistry
    [
      [1, 2, 3, 4, 5, 6],
      ["1c", "2c"],
    ],
    // Physics
    [
      [1, 2, 3, 4, 5, 6],
      ["1p", "2p"],
    ],
    // Math
    [
      [1, 2, 3, 4],
      ["1f", "2f", "3h", "4h", "1h", "2h"],
    ],
    // Economic
    [
      [1, 2, 3, 4, 5, 6],
      [1, 2],
    ],
  ],
  // AP
  [
    // Biology
    [
      [1, 2, 3, 4, 5, 6],
      ["1b", "2b"],
    ],
    // Chemistry
    [
      [1, 2, 3, 4, 5, 6],
      ["1c", "2c"],
    ],
    // Physics
    [
      [1, 2, 3, 4, 5, 6],
      ["1p", "2p"],
    ],
    // Math
    [
      [1, 2, 3, 4],
      ["1f", "2f", "3h", "4h", "1h", "2h"],
    ],
    // Economic
    [
      [1, 2, 3, 4, 5, 6],
      [1, 2],
    ],
  ],
];

export const yearArray = [2022, 2021];
